import withAttr from 'flarum/common/utils/withAttr';
import Field from './Field';
import RichTextField from '../components/RichTextField';
import {FieldTemplate} from '../models/JsonTypes';

export default class Content extends Field {
    whiteListConfigProperties(): (keyof FieldTemplate)[] {
        return [
            'content',
        ];
    }

    configure() {
        return m('.Form-group', m(RichTextField, {
            value: this.getConfig('content'),
            onchange: withAttr('value', this.setConfig('content')),
            disabled: this.disabled,
        }));
    }

    fill() {
        // Not used since we override fillView() but it's an abstract method that has to be implemented
        return null;
    }

    fillView() {
        return m('div', m.trust(this.getConfig('contentHtml')));
    }

    displayView() {
        return null;//TODO: as option?
    }
}
